/** 
 * Action Types
 */

export const REQUEST_QUESTIONS = 'REQUEST_QUESTIONS'
export const RECEIVE_QUESTIONS = 'RECEIVE_QUESTIONS'
export const RECEIVE_QUESTIONS_ERROR = 'RECEIVE_QUESTIONS_ERROR'



/** WEBPACK FOOTER **
 ** ./src/constants/questionTypes.js
 **/